import { ReactElement, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { WidgetsDto } from 'src/models/widgets.dto';

import { WidgetHelp } from '../WidgetHelp';
import { WidgetMenuOfLinks } from '../WidgetMenuOfLinks';
import { WidgetSingleLink } from '../WidgetSingleLink';
import { WidgetTitleRef } from '../WidgetTitle';

import styles from './styles.module.scss';

import { processRouterParams } from ':utils';

export function WidgetHead({
  help,
  service,
  name,
  urls,
}: Pick<WidgetsDto, 'help' | 'service' | 'name' | 'urls'>): ReactElement {
  const routerParams = useParams();

  const { color, icon } = service;
  const { main, background } = color;

  const urlsWithParams = useMemo(
    () =>
      urls.map(item => ({
        ...item,
        url: processRouterParams(item.url, item.is_internal, routerParams),
      })),
    [urls, routerParams]
  );

  return (
    <div className={styles.head}>
      <WidgetTitleRef
        url={urlsWithParams[0]?.url}
        iconName={icon}
        iconBgColor={background}
        iconColor={main}
        title={name}
      />

      {help?.trim() && <WidgetHelp help={help} />}

      {urlsWithParams.length > 0 && (
        <>
          {urlsWithParams.length === 1 ? (
            <WidgetSingleLink {...urlsWithParams[0]} />
          ) : (
            <WidgetMenuOfLinks urls={urlsWithParams} />
          )}
        </>
      )}
    </div>
  );
}
